// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {useReducer, useEffect, useCallback} from 'react';
import {www_hola} from 'hola_opt';
import zutil from 'zutil';
import {
    sessions_reducer,
    SESSION_ACTIONS,
} from './sessions_reducer';
import {use_sessions_ws} from './use_sessions_ws';
import {use_sessions_polling} from './use_sessions_polling';
import {i_zone_session_state} from './types';
import {use_state_ref} from '../../../../shared/hooks/use_state_ref';
import {i_user_info} from 'hola_app_context';

export const use_zone_sessions = (user: i_user_info, use_sessions?: boolean)=>{
    const [state, dispatch] = useReducer(sessions_reducer, {
        zone_id: null,
        is_busy: false,
        sessions: [],
        results: {},
        error: null,
    } as i_zone_session_state);
    const state_ref = use_state_ref(state);
    const {fetch_sessions, update_interval} = use_sessions_polling(dispatch);
    const {is_connected} = use_sessions_ws(dispatch, state_ref, user,
        use_sessions);
    const set_zone_id = useCallback((zone_id: string)=>{
        if (zone_id !== state.zone_id)
        {
            dispatch({type: SESSION_ACTIONS.SET_ZONE_ID,
                payload: zone_id || ''});
            fetch_sessions(zone_id);
        }
    }, [state.zone_id]);
    useEffect(()=>{
        update_interval(is_connected
            ? zutil.get(www_hola, 'sessions_polling_interval', null)
            : zutil.get(www_hola, 'sessions_polling_interval_offline', 3000),
        );
    }, [is_connected]);
    return {
        state,
        sessions: state.sessions,
        results: state.results,
        set_zone_id,
    };
};
